// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__xUi7y","spinner":"Loader_spinner__5Ym2l","spin":"Loader_spin__cgLy8"};